import React from "react";
import { LoadingScreen } from "../LoadingScreen";
import { useBIServerStatus } from "../hooks/useBIServerStatus";
import { ConnectionError } from "@/pages/ConnectionError";
import { MaintenanceTrip } from "@/svg/MaintenanceTrip";

export function MaintenanceGuard({ children }: React.PropsWithChildren) {
  const status = useBIServerStatus({ fetchEvery: 60000 });

  if (status.isError) {
    return <ConnectionError />;
  }

  if (status.isLoading || !status.isSuccess) {
    return <LoadingScreen />;
  }

  if (!status.data.available) {
    return <Maintenance />;
  }

  return children;
}

function Maintenance() {
  return (
    <div className="flex min-h-dvh w-full flex-col items-center justify-center gap-4 bg-background px-4 py-10 text-center text-foreground">
      <MaintenanceTrip />
      <h1 className="text-3xl font-title tracking-tight text-balance md:text-[32px]">
        Maintenance in Progress
      </h1>
      <p className="font-label text-muted-foreground">We will be back soon!</p>
    </div>
  );
}
